// US phone formatting as the guest types: "5551234567" reads "(555) 123-4567". Shared by the embed
// renderer (form.js) and the app's mask controller; no imports, so the embed pack stays self-contained.
export function formatUsPhone(value) {
  // No US area code starts with 1, so a leading 1 is the country code, as in autofill's "+1 555 123 4567".
  const digits = String(value || '').replace(/\D/g, '').replace(/^1/, '')
  const parts = digits.match(/(\d{0,3})(\d{0,3})(\d{0,4})/)
  if (!parts[2]) return parts[1]
  return `(${parts[1]}) ${parts[2]}${parts[3] ? `-${parts[3]}` : ''}`
}
